export const locationsSelector = state => state.locations;
